export default __webpack_public_path__ + "img/c4ec87a5fffaa65912e46f889519aa77.svg";